const regions = {
  US: {
    AL: {
      name: "Alabama",
    },
    AK: {
      name: "Alaska",
    },
    AS: {
      name: "American Samoa",
    },
    AZ: {
      name: "Arizona",
    },
    AR: {
      name: "Arkansas",
    },
    AA: {
      name: "Armed Forces (AA)",
    },
    AE: {
      name: "Armed Forces (AE)",
    },
    AP: {
      name: "Armed Forces (AP)",
    },
    CA: {
      name: "California",
    },
    CO: {
      name: "Colorado",
    },
    CT: {
      name: "Connecticut",
    },
    DE: {
      name: "Delaware",
    },
    DC: {
      name: "District of Columbia",
    },
    FL: {
      name: "Florida",
    },
    GA: {
      name: "Georgia",
    },
    GU: {
      name: "Guam",
    },
    HI: {
      name: "Hawaii",
    },
    ID: {
      name: "Idaho",
    },
    IL: {
      name: "Illinois",
    },
    IN: {
      name: "Indiana",
    },
    IA: {
      name: "Iowa",
    },
    KS: {
      name: "Kansas",
    },
    KY: {
      name: "Kentucky",
    },
    LA: {
      name: "Louisiana",
    },
    ME: {
      name: "Maine",
    },
    MH: {
      name: "Marshall Islands",
    },
    MD: {
      name: "Maryland",
    },
    MA: {
      name: "Massachusetts",
    },
    MI: {
      name: "Michigan",
    },
    FM: {
      name: "Micronesia",
    },
    MN: {
      name: "Minnesota",
    },
    MS: {
      name: "Mississippi",
    },
    MO: {
      name: "Missouri",
    },
    MT: {
      name: "Montana",
    },
    NE: {
      name: "Nebraska",
    },
    NV: {
      name: "Nevada",
    },
    NH: {
      name: "New Hampshire",
    },
    NJ: {
      name: "New Jersey",
    },
    NM: {
      name: "New Mexico",
    },
    NY: {
      name: "New York",
    },
    NC: {
      name: "North Carolina",
    },
    ND: {
      name: "North Dakota",
    },
    MP: {
      name: "Northern Mariana Islands",
    },
    OH: {
      name: "Ohio",
    },
    OK: {
      name: "Oklahoma",
    },
    OR: {
      name: "Oregon",
    },
    PW: {
      name: "Palau",
    },
    PA: {
      name: "Pennsylvania",
    },
    PR: {
      name: "Puerto Rico",
    },
    RI: {
      name: "Rhode Island",
    },
    SC: {
      name: "South Carolina",
    },
    SD: {
      name: "South Dakota",
    },
    TN: {
      name: "Tennessee",
    },
    TX: {
      name: "Texas",
    },
    UT: {
      name: "Utah",
    },
    VT: {
      name: "Vermont",
    },
    VI: {
      name: "Virgin Islands",
    },
    VA: {
      name: "Virginia",
    },
    WA: {
      name: "Washington",
    },
    WV: {
      name: "West Virginia",
    },
    WI: {
      name: "Wisconsin",
    },
    WY: {
      name: "Wyoming",
    },
  },
  CA: {
    AB: {
      local_name: "Alberta",
      name: "Alberta",
    },
    BC: {
      local_name: "Colombie-Britannique",
      name: "British Columbia",
    },
    MB: {
      local_name: "Manitoba",
      name: "Manitoba",
    },
    NB: {
      local_name: "Nouveau-Brunswick",
      name: "New Brunswick",
    },
    NL: {
      local_name: "Terre-Neuve-et-Labrador",
      name: "Newfoundland and Labrador",
    },
    NT: {
      local_name: "Territoires du Nord-Ouest",
      name: "Northwest Territories",
    },
    NS: {
      local_name: "Nouvelle-Écosse",
      name: "Nova Scotia",
    },
    NU: {
      local_name: "Nunavut",
      name: "Nunavut",
    },
    ON: {
      local_name: "Ontario",
      name: "Ontario",
    },
    PE: {
      local_name: "Île-du-Prince-Édouard",
      name: "Prince Edward Island",
    },
    QC: {
      local_name: "Québec",
      name: "Quebec",
    },
    SK: {
      local_name: "Saskatchewan",
      name: "Saskatchewan",
    },
    YT: {
      local_name: "Yukon",
      name: "Yukon",
    },
  },
  KR: {
    "Gangwon-do": {
      local_name: "강원",
      name: "Gangwon-do",
    },
    "Gyeonggi-do": {
      local_name: "경기",
      name: "Gyeonggi-do",
    },
    "Gyeongsangnam-do": {
      local_name: "경남",
      name: "Gyeongsangnam-do",
    },
    "Gyeongsangbuk-do": {
      local_name: "경북",
      name: "Gyeongsangbuk-do",
    },
    Gwangju: {
      local_name: "광주",
      name: "Gwangju",
    },
    Daegu: {
      local_name: "대구",
      name: "Daegu",
    },
    Daejeon: {
      local_name: "대전",
      name: "Daejeon",
    },
    Busan: {
      local_name: "부산",
      name: "Busan",
    },
    Seoul: {
      local_name: "서울",
      name: "Seoul",
    },
    Sejong: {
      local_name: "세종",
      name: "Sejong",
    },
    Ulsan: {
      local_name: "울산",
      name: "Ulsan",
    },
    Incheon: {
      local_name: "인천",
      name: "Incheon",
    },
    "Jeollanam-do": {
      local_name: "전남",
      name: "Jeollanam-do",
    },
    "Jeollabuk-do": {
      local_name: "전북",
      name: "Jeollabuk-do",
    },
    "Jeju-do": {
      local_name: "제주",
      name: "Jeju-do",
    },
    "Chungcheongnam-do": {
      local_name: "충남",
      name: "Chungcheongnam-do",
    },
    "Chungcheongbuk-do": {
      local_name: "충북",
      name: "Chungcheongbuk-do",
    },
  },
  CO: {
    DC: {
      name: "Distrito Capital de Bogotá",
    },
    AMA: {
      name: "Amazonas",
    },
    ANT: {
      name: "Antioquia",
    },
    ARA: {
      name: "Arauca",
    },
    ATL: {
      name: "Atlántico",
    },
    BOL: {
      name: "Bolívar",
    },
    BOY: {
      name: "Boyacá",
    },
    CAL: {
      name: "Caldas",
    },
    CAQ: {
      name: "Caquetá",
    },
    CAS: {
      name: "Casanare",
    },
    CAU: {
      name: "Cauca",
    },
    CES: {
      name: "Cesar",
    },
    COR: {
      name: "Córdoba",
    },
    CUN: {
      name: "Cundinamarca",
    },
    CHO: {
      name: "Chocó",
    },
    GUA: {
      name: "Guanía",
    },
    GUV: {
      name: "Guaviare",
    },
    HUI: {
      name: "Huila",
    },
    LAG: {
      name: "La Guajira",
    },
    MAG: {
      name: "Magdalena",
    },
    MET: {
      name: "Meta",
    },
    NAR: {
      name: "Nariño",
    },
    NSA: {
      name: "Norte de Santander",
    },
    PUT: {
      name: "Putumayo",
    },
    QUI: {
      name: "Quindío",
    },
    RIS: {
      name: "Risaralda",
    },
    SAP: {
      name: "San Andrés, Providencia y Santa Catalina",
    },
    SAN: {
      name: "Santander",
    },
    SUC: {
      name: "Sucre",
    },
    TOL: {
      name: "Tolima",
    },
    VAC: {
      name: "Valle del Cauca",
    },
    VAU: {
      name: "Vaupés",
    },
    VID: {
      name: "Vichada",
    },
  },
  MX: {
    JAL: {
      name: "Jalisco",
    },
    "B.C.": {
      name: "Baja california",
    },
  },
  EG: {
    ASN: { name: "Aswan Governorate" },
    C: { name: "Cairo Governorate" },
    LX: { name: "Luxor Governorate" },
  },

  CL: {
    LL: { name: "Los Lagos" },
  },

  PE: {
    ARE: { name: "Arequipa" },
    CUS: { name: "Cusco" },
    LIM: { name: "Gobierno Regional de Lima" },
    PUN: { name: "Puno" },
  },
};
exports.regions = regions;
exports.getAddressStateName = (countryCode, stateCode) => {
  const stateName = regions[countryCode]
    ? regions[countryCode][stateCode]?.name
    : stateCode;
  return removePrepositionsFromString(stateName);
};
const removePrepositionsFromString = (inputString) => {
  const prepositions = [
    "a",
    "an",
    "as",
    "at",
    "before",
    "but",
    "by",
    "for",
    "from",
    "is",
    "in",
    "into",
    "like",
    "of",
    "off",
    "on",
    "onto",
    "per",
    "since",
    "than",
    "the",
    "this",
    "that",
    "to",
    "up",
    "via",
    "with",
  ];
  let resultString = inputString;
  if (!inputString) return inputString;

  prepositions.forEach((preposition) => {
    const regex = new RegExp(`\\b${preposition}\\b`, "gi");
    resultString = resultString.replace(regex, "").replace("  ", " ");
  });

  return resultString;
};
const getRegionName = (regionCode, country) => {
  let response = regionCode;
  if (!regions[country]) {
    return response;
  }
  const states = Object.entries(regions[country]);
  for (let i = 0; i < states.length; i++) {
    if (regionCode === states[i][0].toLowerCase()) {
      response = states[i][1].name;
      break;
    }
  }
  return response;
};
const getRegionCode = (regionName, country) => {
  let response = regionName;
  if (!regions[country]) {
    return response;
  }
  const states = Object.entries(regions[country]);
  for (let i = 0; i < states.length; i++) {
    if (regionName === states[i][1].name.toLowerCase()) {
      response = states[i][0].toLowerCase();
      break;
    }
  }
  return response;
};
exports.getPaths = (alias) => {
  const segments = alias.split("/");
  let _codePath, _fullPath, regionCode, regionName;
  const country = segments[2].toUpperCase();
  const region = segments[3] ? segments[3] : "";
  if (region.length === 2) {
    regionCode = region;
    regionName = getRegionName(region, country);
  } else {
    regionName = region;
    regionCode = getRegionCode(region, country);
  }

  segments.map((x, i) => {
    switch (i) {
      case 0:
        _codePath = "/";
        _fullPath = "/";
        break;
      case 3:
        _codePath += `${regionCode}/`;
        _fullPath += `${regionName}/`;
        break;
      default:
        _codePath += `${x}/`;
        _fullPath += `${x}/`;
        break;
    }
  });
  const response = {
    codePath: _codePath.substring(0, _codePath.length - 1).toLowerCase(),
    fullPath: _fullPath.substring(0, _fullPath.length - 1).toLowerCase(),
  };
  return response;
};
